import { gql } from '@edreamsodigeo/frontend-api-client';
import { itinerarySearchSection } from './itinerarySearchSection';

export const itinerarySearchSegment = gql`
  fragment SegmentInfo on ItinerarySearchResultSegment {
    id
    duration
    carrierId
    sections {
      ...SectionInfo
    }
    baggageCondition
    transportTypes
  }

  ${itinerarySearchSection}
`;
